import "./boxShadow.scss";

const BoxShadow = (props: any) => {
  const { children } = props;
  return <div className="box__shadow">{children}</div>;
};

export default BoxShadow;
